var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._g(_vm._b({attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._t("wrap-me",[_c('v-icon',{staticClass:"pb-1 d-print-none",attrs:{"small":""}},[_vm._v(" mdi-information-variant ")])])],2)]}}],null,true)},'v-tooltip',[_vm.$attrs, _vm.$props],false),_vm.$listeners),[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }